// tslint:disable-next-line:max-line-length
import { BitfPApiCallStateMapper } from '@common/libs/bitforce/core/api-call-state/bitf-p-api-call-state/bitf-p-api-call-state.mapper';

export class DefaultApiCallStateMapper extends BitfPApiCallStateMapper {}
